import { render, staticRenderFns } from "./DAOdontogramTreatment.vue?vue&type=template&id=c7f717c6&scoped=true"
import script from "./DAOdontogramTreatment.vue?vue&type=script&lang=js"
export * from "./DAOdontogramTreatment.vue?vue&type=script&lang=js"
import style0 from "./DAOdontogramTreatment.vue?vue&type=style&index=0&id=c7f717c6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c7f717c6",
  null
  
)

export default component.exports